import type { Lang } from './types';

export const phone = '+91 9500549549';
export const routes = [
  '/', '/goddess', '/peetam', '/priest', '/worship', '/panchangam', '/festivals',
  '/live-gallery', '/live', '/videos', '/learning', '/maha-periyava', '/visit', '/faq', '/privacy', '/accessibility', '/rights', '/review-guide', '/editor'
] as const;

export const nav = [
  ['/', 'Home', 'முகப்பு'],
  ['/goddess', 'Sri Raja Matangi', 'ஸ்ரீ ராஜ மாதங்கி'],
  ['/peetam', 'Our Peetam', 'எங்கள் பீடம்'],
  ['/worship', 'Pooja & Worship', 'பூஜை & வழிபாடு'],
  ['/live', 'Live Darshan', 'நேரலை தரிசனம்'],
  ['/visit', 'Visit & Contact', 'வருகை & தொடர்பு']
] as const;

export const copy = {
  en: {
    review: 'PRIVATE PREVIEW',
    temple: 'SRI SRI RAJAMATHANGI MAHAPEEDAM · KUMBAKONAM',
    heroTitle: 'In devotion, a deeper understanding.',
    heroBody: 'Enter a world of worship, sacred learning and living tradition at Sri Sri Rajamathangi Mahapeedam in Kumbakonam.',
    discover: 'Discover Sri Raja Matangi',
    worship: 'Explore worship',
    welcomeKicker: 'WELCOME TO THE PEETAM',
    welcomeTitle: 'A sacred experience to enter. A living tradition to understand.',
    welcomeBody: 'Sri Sri Rajamathangi Mahapeedam brings together worship, homa, sacred time and source-grounded learning in an intimate Kumbakonam setting.',
    goddessKicker: 'DISCOVER THE GODDESS',
    goddessTitle: 'Speech. Music. The joy of learning.',
    goddessBody: 'Śyāmalā devotional literature gives us imagery of the veena and a love of music. Read these motifs in their textual setting and discover how they illuminate the worship tradition of the Peetam.',
    priestKicker: 'FOUNDER · PRIEST · RELIGIOUS GUIDE',
    priestBody: 'Sri Muthu Kumar Sivachariyar, founder and Peetadhipathi, leads worship, homa, sacred learning and direct spiritual guidance at the Peetam.',
    calendarEmpty: 'The Peetam calendar is updated as festivals, special worship and sacred observances are scheduled.',
    visitBody: 'For a visit, special pooja enquiry or guidance, contact Sri Sri Rajamathangi Mahapeedam directly.',
    draft: 'Sacred learning · source-grounded presentation',
    notSupplied: 'DETAILS TO BE ADDED',
    mediaNote: 'Sri Sri Rajamathangi Mahapeedam photo and video collection.'
  },
  ta: {
    review: 'தனிப்பட்ட முன்னோட்டம்',
    temple: 'ஸ்ரீ ராஜ மாதங்கி பீடம் · கும்பகோணம்',
    heroTitle: 'பக்தியில் ஆழமான புரிதல்.',
    heroBody: 'புனிதக் கற்றல், வழிபாடு மற்றும் இசையின் உலகிற்குள் வாருங்கள். ஸ்ரீ முத்து குமார் சிவாச்சாரியாரின் வழிகாட்டுதலுடன் தெய்வத்தையும் பீடத்தையும் அறிந்து கொள்ளுங்கள்.',
    discover: 'ஸ்ரீ ராஜ மாதங்கியை அறியுங்கள்',
    worship: 'வழிபாட்டை அறியுங்கள்',
    welcomeKicker: 'பீடத்திற்கு வரவேற்கிறோம்',
    welcomeTitle: 'அறிய ஒரு புனித இடம். புரிந்து கொள்ள ஒரு மரபு.',
    welcomeBody: 'ஸ்ரீ ராஜ மாதங்கி பீடம் கும்பகோணத்தின் புனித வழிபாட்டு மரபையும் தேவியைப் பற்றிய ஆதாரபூர்வமான கற்றலையும் ஒன்றிணைக்கிறது.',
    goddessKicker: 'தேவியை அறியுங்கள்',
    goddessTitle: 'வாக்கு. இசை. கற்றலின் ஆனந்தம்.',
    goddessBody: 'சியாமளா பக்தி இலக்கியம் வீணை, இசை மற்றும் புனித வாக்கின் அழகை வெளிப்படுத்துகிறது. அவற்றை உரிய நூல் சூழலில் அறிந்து கொள்ளுங்கள்.',
    priestKicker: 'நிறுவனர் · ஆசாரியர் · ஆன்மீக வழிகாட்டி',
    priestBody: 'பீடத்தின் மையத்தில் நிறுவனர் மற்றும் பீடாதிபதியான ஸ்ரீ முத்து குமார் சிவாச்சாரியாரின் ஆன்மீக வழிகாட்டுதல் உள்ளது.',
    calendarEmpty: 'பீடத்தின் விழா மற்றும் நிகழ்வு தகவல்கள் சேர்க்கப்படும் போது இங்கு காணலாம்.',
    visitBody: 'வருகை, சிறப்பு பூஜை அல்லது வழிகாட்டுதலுக்கு ஸ்ரீ ராஜ மாதங்கி பீடத்தை நேரடியாக தொடர்புகொள்ளுங்கள்.',
    draft: 'புனிதக் கற்றல் · ஆதாரபூர்வமான விளக்கம்',
    notSupplied: 'விவரங்கள் சேர்க்கப்படுகின்றன',
    mediaNote: 'ஸ்ரீ ராஜ மாதங்கி பீடத்தின் படம் மற்றும் காணொளி தொகுப்பு.'
  }
} satisfies Record<Lang, Record<string, string>>;

export const sources = [
  { id:'SRC-01', title:'Ṛgveda, Śākala Saṃhitā 10.125', locator:'Hymn 10.125, verses 1–8; especially 3–5', body:'The hymn attributed to Vāk Ambhṛṇī presents divine agency in first-person speech. It offers context for sacred speech; the inspected passage does not name Raja Matangi.', url:'https://vedicheritage.gov.in/hi/samhitas/rigveda/shakala-samhita/rigveda-shakala-samhita-mandal-10-sukta-125/' },
  { id:'SRC-02', title:'Lalitā Sahasranāma', locator:'Stanza 26; stanza 29 also names Mantriṇyambā', body:'Stanza 26 describes Lalitā as attended by Mantriṇī riding the Geya Cakra. This is a textual reference, not a claim about every later lineage or Peetam ritual.', url:'https://sanskritdocuments.org/doc_devii/lalita.html' },
  { id:'SRC-03', title:'Śyāmalā Daṇḍakam', locator:'Opening dhyāna and introductory verses', body:'The text depicts Śyāmalā with a veena and invokes her as the daughter of Matanga, with imagery associated with music and a parrot. Historical authorship remains unverified here.', url:'https://sanskritdocuments.org/doc_devii/shyaamala.html' }
];

export const learningJourneys = [
  ['Sacred speech', 'Read Ṛgveda 10.125 in context and distinguish the hymn’s Vāk theology from later identifications.'],
  ['The veena and music', 'Trace the musical imagery in Śyāmalā Daṇḍakam without turning poetic motifs into unsupported temple history.'],
  ['Mantriṇī in Lalitā tradition', 'Locate the Geya Cakra reference in Lalitā Sahasranāma and note what the text does and does not say.'],
  ['Names and iconography', 'Study names, forms and shrine iconography with clear source distinctions.'],
  ['Peetam oral history', 'Present the founder’s lineage, training and the Peetam’s establishment as part of its living history.'],
  ['Worship vocabulary', 'Build a glossary for common terms used in pooja, homa, sankalpa and arati.'],
  ['Kumbakonam context', 'Add verified local history only where it directly helps visitors understand the Peetam.'],
  ['Living tradition', 'Turn unresolved research into respectful, numbered questions that are easy to answer by voice note.']
];

export const media = [
  {id:'01',type:'video',src:'/media/01.mp4',poster:'/media/01-poster.webp',en:'Supplied recording of decorated shrines and worship',ta:'அலங்கரிக்கப்பட்ட சன்னதிகள் மற்றும் வழிபாட்டின் பதிவு'},
  {id:'02',type:'image',src:'/media/02.webp',en:'Flower-adorned shrine during arati',ta:'மலர் அலங்காரத்துடன் தீபாராதனை'},
  {id:'03',type:'image',src:'/media/03.webp',en:'Sri Muthu Kumar Sivachariyar conducting worship',ta:'ஸ்ரீ முத்து குமார் சிவாச்சாரியார் வழிபாடு செய்கிறார்'},
  {id:'04',type:'image',src:'/media/04.webp',en:'Supplied deity photograph with veena and ceremonial adornment',ta:'வீணையுடன் அலங்கரிக்கப்பட்ட தெய்வத் திருவுருவம்'},
  {id:'05',type:'image',src:'/media/05.webp',en:'Priests conducting homa in the worship hall',ta:'வழிபாட்டு மண்டபத்தில் ஹோமம் நடைபெறுகிறது'},
  {id:'06',type:'image',src:'/media/06.webp',en:'A shrine adorned with flowers and jewellery',ta:'மலர்கள் மற்றும் ஆபரணங்களால் அலங்கரிக்கப்பட்ட சன்னதி'},
  {id:'07',type:'video',src:'/media/07.mp4',poster:'/media/07-poster.webp',en:'Supplied recording of worship and decorated shrines',ta:'வழிபாடு மற்றும் அலங்கரிக்கப்பட்ட சன்னதிகளின் பதிவு'}
] as const;